<template>
  <a-popover
    v-model:visible="isVisible"
    trigger="click"
    placement="bottomRight"
    :overlay-style="{ width: '360px' }"
  >
    <template #content>
      <a-form
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-item :label="$tm('statistic.table.filter.name')">
          <a-input
            v-model:value="form.name"
          />
        </a-form-item>
        <a-form-item :label="$tm('statistic.table.filter.publishedStatus')">
          <a-select v-model:value="form.publishStatus">
            <a-select-option value="已发布">
              {{ filterTm('published') }}
            </a-select-option>
            <a-select-option value="未发布">
              {{ filterTm('unpublished') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$tm('statistic.table.filter.alignedStatus')">
          <a-select v-model:value="form.alignStatus">
            <a-select-option value="已对齐">
              {{ filterTm('aligned') }}
            </a-select-option>
            <a-select-option value="未对齐">
              {{ filterTm('unaligned') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$tm('statistic.table.filter.updatedStatus')">
          <a-select v-model:value="form.updateStatus">
            <a-select-option value="已更新">
              {{ filterTm('updated') }}
            </a-select-option>
            <a-select-option value="未更新">
              {{ filterTm('unupdated') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$tm('statistic.table.filter.reviewedStatus')">
          <a-select v-model:value="form.reviewStatus">
            <a-select-option value="已复盘">
              {{ filterTm('reviewed') }}
            </a-select-option>
            <a-select-option value="未复盘">
              {{ filterTm('unreviewed') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 8, span: 24 }">
          <a-button @click="onReset">
            {{ $t('shared.reset') }}
          </a-button>
          <a-button
            type="primary"
            style="margin-left: 10px"
            @click="onSubmit"
          >
            {{ $t('shared.ok') }}
          </a-button>
        </a-form-item>
      </a-form>
    </template>
    <a-button class="bg-btn">
      <template #icon>
        <IconFont
          type="iconshaixuan"
          class="icon-block"
        />
      </template>
    </a-button>
  </a-popover>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue'
import { useI18n } from 'vue-i18n'

const field2FilterMap = {
  name: 'User.display_name',
  fillInStatus: 'UserCycle.update_desc',
  publishStatus: 'UserCycle.publish_desc',
  updateStatus: 'UserCycle.update_desc',
  reviewStatus: 'UserCycle.review_desc'
}

const defaultForm = {
  name: '',
  fillInStatus: '',
  publishStatus: '',
  alignStatus: '',
  updateStatus: '',
  reviewStatus: ''
}

export default defineComponent({
  name: 'UserStatusTableFilter',
  components: {},
  props: {},
  emits: ['filter'],
  setup (props, { emit }) {
    const { tm } = useI18n()
    const isVisible = ref(false)
    const form = reactive({ ...defaultForm })

    function onSubmit () {
      const filters = []
      for (const [key, val] of Object.entries(form)) {
        if (val !== '') {
          filters.push({
            dimension: field2FilterMap[key],
            operator: key === 'name' ? 'contains' : 'equals',
            values: [val]
          })
        }
      }

      isVisible.value = false
      emit('filter', filters)
    }

    function onReset () {
      Object.assign(form, { ...defaultForm })
      emit('filter', [])
      isVisible.value = false
    }

    function filterTm (name) {
      return tm('statistic.table.filter.options.' + name)
    }

    return {
      isVisible,
      form,
      onSubmit,
      onReset,
      filterTm
    }
  }
})
</script>
